import { createApp } from 'vue'
import App from './App.vue'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import router from './router'
import vueScrollto from 'vue-scrollto';


router.beforeEach((to, from, next) => {
    /* 路由发生变化修改页面meta */
    let head = document.getElementsByTagName('head');

    if (to.meta.keywords) {
        let meta = document.createElement('meta');
        meta.name = 'keywords';
        meta.content = to.meta.keywords;
        head[0].appendChild(meta)
    }
    if (to.meta.description) {
        let meta = document.createElement('meta');
        meta.name = 'description';
        meta.content = to.meta.description;
        head[0].appendChild(meta)
    }
    /* 路由发生变化修改页面title */
    if (to.meta.title) {
        document.title = to.meta.title;
    }
    next()
});



const app = createApp(App)

app.config.globalProperties.$httpImg = 'https://chaopin-official-website.oss-cn-chengdu.aliyuncs.com'
app.use(ElementPlus)
app.use(router)
app.use(vueScrollto);
app.mount('#app')
